import React, { useState, useEffect } from 'react';
import './Header.css';
import { SettingsIcon } from '../SettingsIcon';
import { PhoneIcon } from '../PhoneIcon';
import { BookOpenIcon } from '../BookOpenIcon';
import { BlocksIcon } from '../BlocksIcon';
import { HomeIcon } from '../HomeIcon';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { id: 'home', label: 'Home', icon: <HomeIcon size={20} /> },
    { id: 'about', label: 'About', icon: <BookOpenIcon size={20} /> },
    { id: 'services', label: 'Services', icon: <SettingsIcon size={20} /> },
    { id: 'customers', label: 'Customers', icon: <BlocksIcon size={20} /> },
    { id: 'contact', label: 'Contact', icon: <PhoneIcon size={20} /> },
  ];

  return (
    <>
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <nav className="navbar">
            <div className="logo" onClick={() => scrollToSection('home')}>
              <img src="/logo.png" alt="Octopus Industries" />
              <span className="logo-text">Octopus Industries</span>
            </div>

            <button 
              className={`mobile-menu-fab ${isMobileMenuOpen ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? '✕' : '☰'}
            </button>

            <ul className="nav-menu desktop-menu">
              {navItems.map(item => (
                <li key={item.id}>
                  <button onClick={() => scrollToSection(item.id)}>{item.label}</button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </header>

      {/* Mobile Bottom Navigation */}
      <nav className={`mobile-bottom-nav ${isMobileMenuOpen ? 'active' : ''}`}>
        {navItems.map(item => (
          <button 
            key={item.id}
            className="nav-item"
            onClick={() => scrollToSection(item.id)}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </button>
        ))}
      </nav>
    </>
  );
};

export default Header;
